module.exports = __webpack_public_path__ + "static/media/banco estado.45d052db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/banco estado.png
// module id = 322
// module chunks = 0